<template>
  <v-card class="ma-auto card" flat align="center">
    <v-card-title class="mb-8 align-center justify-center">
      <v-img v-if="imgSrc" max-width="190px" contain :src="imgSrc" />
      <v-img v-else max-width="190px" contain src="@/assets/partner_not_found.svg" />
    </v-card-title>
    <v-card-text>
      <p>{{ $t("components.utility.ErrorCard.title") }}</p>
      <p>{{ $t("components.utility.ErrorCard.subtitle") }}</p>

      <v-breadcrumbs :items="items" class="ma-4 align-center justify-center"></v-breadcrumbs>
    </v-card-text>
    <v-card-actions class="align-center justify-center">
      <v-btn v-if="showLoginBtn" :loading="isLoadingLogin" @click="logout" text
        >{{ $t("components.utility.ErrorCard.login") }}
      </v-btn>

      <v-btn :loading="loading" color="primary" elevation="0" @click="reload">
        {{ $t("components.utility.ErrorCard.btnText") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script lang="ts">
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { UserModule } from "@/store/modules/me-user.store";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class ErrorCard extends DarkModeHighlightMixin {
  EVENT_RELOAD = "reload";

  @Prop()
  imgSrc!: string;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: true })
  showLoginBtn!: boolean;

  @Prop()
  items!: [];

  reload() {
    this.$emit(this.EVENT_RELOAD, true);
  }

  isLoadingLogin = false;

  async logout() {
    try {
      this.isLoadingLogin = true;
      await this.performLogout();
      this.$log.info("Logged out successfully");
    } catch {
      this.$log.info("Logged out not successful");
    } finally {
      this.isLoadingLogin = false;
      this.$router.push({ name: "Login" });
    }
  }

  async performLogout() {
    await UserModule.logout();
  }
}
</script>
